<script>
	export let backgroundClass = "bg-base-100";
	export let contentClass = "";
	export let extraClasses = "";
</script>

<div class="card shadow-xl {backgroundClass} {contentClass} {extraClasses}">
	<slot />
</div>
